import PurchaseOrderListCard from "@legacy/purchase_orders/components/PurchaseOrderListCard"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { CardList, Table, ViewBar, ViewMenu } from "@organisms"
import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

import { PurchaseOrderTableViewTabs } from "@pages/PurchaseOrders/PurchaseOrderList/views/PurchaseOrderTableView/PurchaseOrderTableViewTabs"

import { PURCHASE_ORDER_ROUTES } from "@routes/purchase-orders"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import {
    PURCHASE_ORDERS_LIST_CONTROLS_ACTIVE_TAB,
    PURCHASE_ORDERS_LIST_CONTROLS_KEYWORD_SEARCH,
    PURCHASE_ORDERS_LIST_CONTROLS_PHASE,
} from "@constants/storage"

const PURCHASE_ORDER_CARDS_VIEW_ATTRIBUTES = [
    { value: "vendor_name", label: "Purchasing Vendor" },
    { value: "labels", label: "Labels" },
    { value: "item_count", label: "Items" },
    { value: "subtotal", label: "Amount" },
    { value: "shipping", label: "Shipping" },
    { value: "preferred_shipping", label: "Shipping Preference" },
    { value: "date_issued", label: "Issued" },
    { value: "estimated_arrival_time", label: "Est. Arrival" },
    { value: "payment_terms", label: "Payment Terms" },
]

const PURCHASE_ORDER_CARDS_VIEW_SORT_OPTIONS = [
    { value: "id", label: "ID" },
    { value: "vendor_name", label: "Purchasing Vendor" },
    { value: "vendor_internal_id", label: "Vendor PO ID" },
    { value: "status_label", label: "Status" },
    { value: "item_count", label: "Items" },
    { value: "subtotal", label: "Amount" },
    { value: "last_modified_at", label: "Last Modified" },
    { value: "date_issued", label: "Issued" },
    { value: "estimated_arrival_time", label: "Est. Arrival" },
    { value: "payment_terms", label: "Payment Terms" },
    { value: "last_sent_at", label: "Sent" },
    { value: "last_acknowledged_at", label: "Acknowledged" },
    { value: "last_in_transit_at", label: "In Transit" },
    { value: "last_delivered_at", label: "Delivered" },
    { value: "last_stocked_at", label: "Stocked" },
    { value: "last_paid_at", label: "Paid" },
    { value: "last_cancelled_at", label: "Cancelled" },
    { value: "last_viewed", label: "Seen" },
]

export default function PurchaseOrderCardsView() {
    const [createRoute] = useSlugExtractor([PURCHASE_ORDER_ROUTES.CREATE])
    const { hasPermission } = useHasAccess()

    return (
        <Table.Provider
            activePhaseStorageKey={PURCHASE_ORDERS_LIST_CONTROLS_PHASE}
            activeTabStorageKey={PURCHASE_ORDERS_LIST_CONTROLS_ACTIVE_TAB}
            searchKeywordsStorageKey={PURCHASE_ORDERS_LIST_CONTROLS_KEYWORD_SEARCH}
            listTitle="Purchase Orders"
            objectType="purchase_order"
            objectIndexName="PurchaseOrder"
            objectName="Purchase Order"
            defaultActivePhase="open"
            objectCreateRoute={createRoute}
            isRowClickable={hasPermission("purchase_orders_view_permission", PERMISSION_LEVEL.FULL)}
            isEmptyStateCreateButtonVisible={hasPermission(
                "purchase_orders_create_permission",
                PERMISSION_LEVEL.RESTRICTED,
            )}
        >
            <CardsView.Provider
                attributes={PURCHASE_ORDER_CARDS_VIEW_ATTRIBUTES}
                sortOptions={PURCHASE_ORDER_CARDS_VIEW_SORT_OPTIONS}
            >
                <ViewBar.Root>
                    <ViewBar.Start>
                        <ViewBar.Phases>
                            <Table.Phase phase="open" title="Open" />
                            <Table.Phase phase="closed" title="Closed" />
                        </ViewBar.Phases>
                        <ViewBar.VerticalDivider />
                        <PurchaseOrderTableViewTabs />
                    </ViewBar.Start>
                    <ViewBar.End>
                        <Table.SearchInput />
                        <ViewMenu />
                    </ViewBar.End>
                </ViewBar.Root>
                <CardList CardComponent={PurchaseOrderListCard} />
            </CardsView.Provider>
        </Table.Provider>
    )
}
